export const POST_NODES_FILTERED = 'POST_NODES_FILTERED';
export const PROJECT_ERROR = 'PROJECT_ERROR';
export const PROJECT_IS_LOADING = 'PROJECT_IS_LOADING';
export const SET_FILTERS = 'SET_FILTERS';
export const GET_LISTS = 'GET_LISTS';
